import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';
import CircularProgress from '@material-ui/core/CircularProgress';

import _findIndex from 'lodash/findIndex';

function showLoader(enabled) {
  if (enabled) {
    return (
      <div style={{ textAlign: 'center' }}>
        <CircularProgress />
      </div>
    );
  }
}
const KeyManagement = ({
  campaign,
  keys,
  checked,
  status,
  handleToggle,
  handleSubmit,
  hide,
  loaded,
}) => (
  <Dialog open={status} onClose={hide}>
    <DialogTitle disableTypography>
      <Typography variant="h6">Key Management</Typography>
      <Typography variant="subtitle1">{campaign.name}</Typography>
    </DialogTitle>
    {showLoader(!loaded)}
    <DialogContent>
      <List>
        {keys.map(key => (
          <ListItem
            key={key._id}
            dense
            button
            disableGutters
            onClick={handleToggle(key)}
          >
            <Checkbox
              checked={_findIndex(checked, ['_id', key._id]) !== -1}
              color="primary"
              tabIndex={-1}
              disableRipple
            />
            <ListItemText primary={key.name} secondary={key.key} />
          </ListItem>
        ))}
      </List>
    </DialogContent>
    <DialogActions>
      <Button color="primary" onClick={handleSubmit}>
        save
      </Button>
      <Button onClick={hide}>close</Button>
    </DialogActions>
  </Dialog>
);

export default KeyManagement;
